
import GeoJSON from 'ol/format/GeoJSON';
import WKT from 'ol/format/WKT';
import { buffer as extentBuffer } from 'ol/extent';

import MapCommand from './MapCommand';

import { Log } from '../../core';
const log = Log.getLogger('MultiSceneForApp.openlayers.MapCommanderZoomFeature');

export default class MapCommandZoomFeature extends MapCommand {

    constructor(options) {
        super(options);
        this._name = 'ZOOM_FEATURE';
    }

    execute(olMap, params) {
        let geometry = this.getGeometry(params);
        if(geometry) {
            let extent = extentBuffer(geometry.getExtent(), 100);
            let options = params.options || {duration: 500};
            options.size = olMap.getMap().getSize();
            olMap.getView().fit(extent, options);
        }
    }

    getGeometry(params) {
        if (params.geoJson) {
            return this.getGeometryFromGeoJSON(params.geoJson);
        } else {
            if (params.wkt) {
                return this.getGeometryFromWKT(params.wkt);
            } else {
                if (params.geometry) {
                    return params.geometry;
                } else {
                    log.warn(`params does not contain property with geometry ['geoJson','wkt','geometry']`)
                    return null;
                }
            }
        }
    }

    getGeometryFromGeoJSON(geoJson) {
        let format = new GeoJSON();
        return format.readGeometry(geoJson);
    }

    getGeometryFromWKT(wkt) {
        let format = new WKT();
        return format.readGeometry(wkt);
    }
}
